export { Welcome as default } from '@/screens/auth/Welcome'
